// نسخه به‌روز شده Login.js با:
// - اعتبارسنجی شماره عمانی
// - حالت ورود با ایمیل
// - ترجمه کامل متون

import React, { useState } from "react";
import * as yup from "yup";
import { httpReauest } from "../utils/httpRequest";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function Login() {
  const [step, setStep] = useState(1);
  const [method, setMethod] = useState("phone");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [fullName, setFullName] = useState("");
  const [birthDay, setBirthDay] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [error, setError] = useState("");
  const params = new URLSearchParams(window.location.search);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const phoneSchema = yup.object().shape({
    phoneNumber: yup
      .string()
      .matches(/^(?:7|9)\d{7}$/, t("login_invalid_phone"))
      .required(t("login_required_phone")),
  });

  const emailSchema = yup.object().shape({
    email: yup
      .string()
      .email(t("login_invalid_email"))
      .required(t("login_required_email")),
  });

  const handleSendCode = async (e) => {
    e.preventDefault();
    const refCode = params.get("refCode");

    try {
      if (method === "phone") {
        await phoneSchema.validate({ phoneNumber });
        const res = await httpReauest("POST", "/user/login", {
          phone: phoneNumber,
          ref: refCode ? refCode : null,
        });
        if (res.status === 201) setStep(2);
      } else {
        await emailSchema.validate({ email });
        const res = await httpReauest("POST", "/user/login/email", {
          email,
          ref: refCode ? refCode : null,
        });
        if (res.status === 201) setStep(2);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    try {
      const payload =
        method === "phone"
          ? {
              phone: phoneNumber,
              code: verificationCode,
            }
          : { email, code: verificationCode };

      const endpoint =
        method === "phone" ? "/user/login/accept" : "/user/login/email/accept";
      const res = await httpReauest("POST", endpoint, payload);
      if (res.status === 201) {
        localStorage.setItem("user", JSON.stringify(res.data.data));
        if (res.data.data?.name) navigate("/");
        else setStep(3);
      }
    } catch {
      toast.error(t("login_code_error"));
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await httpReauest(
      "POST",
      "/user/edit",
      {
        name: fullName,
        birthdate: `${birthYear}-${birthMonth}-${birthDay}`,
      },
      {
        "x-access-token": user?.token,
      }
    );
    if (res.status === 201) navigate("/");
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-3">
      <div className="bg-white p-8 rounded-2xl shadow-md w-full max-w-sm">
        <img src="/logo.png" className="w-[100px] mx-auto" alt="Sambite Logo" />
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">
          {t("login_title")}
        </h2>

        {step === 1 && (
          <>
            <div className="flex gap-3 mb-4">
              <button
                onClick={() => setMethod("phone")}
                className={`w-1/2 py-2 rounded-lg ${
                  method === "phone" ? "bg-blue-500 text-white" : "bg-gray-100"
                }`}
              >
                {t("login_with_phone")}
              </button>
              <button
                onClick={() => setMethod("email")}
                className={`w-1/2 py-2 rounded-lg ${
                  method === "email" ? "bg-blue-500 text-white" : "bg-gray-100"
                }`}
              >
                {t("login_with_email")}
              </button>
            </div>
            <form onSubmit={handleSendCode}>
              {method === "phone" ? (
                <>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    {t("login_phone_label")}
                  </label>
                  <input
                    type="tel"
                    placeholder="7xxxxxxx or 9xxxxxxx"
                    className="w-full px-4 py-2 border rounded-lg"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    required
                  />
                </>
              ) : (
                <>
                  <label className="block mb-2 text-sm font-medium text-gray-700">
                    {t("login_email_label")}
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 border rounded-lg"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </>
              )}
              {error && <small className="text-red-500">{error}</small>}
              <button
                type="submit"
                className="w-full mt-6 bg-[var(--primary)] text-white py-2 rounded-lg"
              >
                {t("login_send_code")}
              </button>
            </form>
          </>
        )}

        {step === 2 && (
          <form onSubmit={handleVerifyCode}>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              {t("login_code_label")}
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 border rounded-lg"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
            />
            <button
              type="submit"
              className="w-full mt-6 bg-[var(--secondry)] text-white py-2 rounded-lg"
            >
              {t("login_verify")}
            </button>
          </form>
        )}

        {step === 3 && (
          <form onSubmit={handleProfileSubmit}>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              {t("login_name_label")}
            </label>
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border rounded-lg"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
            <label className="block mb-2 text-sm font-medium text-gray-700">
              {t("login_birthdate_label")}
            </label>
            <div className="flex space-x-2 rtl:space-x-reverse mb-4">
              <input
                type="text"
                placeholder={t("login_birth_day")}
                className="w-1/3 px-3 py-2 border rounded-lg text-center"
                value={birthDay}
                onChange={(e) => setBirthDay(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder={t("login_birth_month")}
                className="w-1/3 px-3 py-2 border rounded-lg text-center"
                value={birthMonth}
                onChange={(e) => setBirthMonth(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder={t("login_birth_year")}
                className="w-1/3 px-3 py-2 border rounded-lg text-center"
                value={birthYear}
                onChange={(e) => setBirthYear(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full mt-4 bg-[var(--primary)] text-white py-2 rounded-lg"
            >
              {t("login_submit_info")}
            </button>
          </form>
        )}

        <div className="mt-4 text-center text-sm text-gray-500">
          {(step === 2 || step === 3) && (
            <button
              onClick={() => setStep(step - 1)}
              className="text-blue-500 hover:underline"
            >
              {t("login_back")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
